export default __webpack_public_path__ + "static/media/new.593250bd.svg";